import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HERO_BG = "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/hrspem2q_Aerial_B.jpg";

export default function HeroSection() {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="hero-section" className="relative min-h-[90vh] flex items-end overflow-hidden pt-20">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover hero-bg-animate"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pb-24 lg:pb-32 pt-32">
        <div className="max-w-3xl">
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-[1.08] uppercase animate-fade-in-up"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="hero-headline"
          >
            <span className="text-[#D49A38]">Operate within</span> a structured business framework in Jamaica
          </h1>

          <p
            className="mt-8 text-base md:text-lg text-white/80 leading-relaxed max-w-2xl animate-fade-in-up animate-delay-200"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="hero-subtext"
          >
            Tailwind Corporation develops and operates business facilities within a framework designed to support international operations and regional access.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-in-up animate-delay-400">
            <Button
              asChild
              className="bg-[#D49A38] text-white hover:bg-[#c08a2e] rounded-full px-8 py-6 text-base font-semibold transition-all duration-300 shadow-lg"
              data-testid="hero-cta-primary"
            >
              <a href="https://1141bc.com/units" target="_blank" rel="noopener noreferrer">
                Browse Available Units
                <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            </Button>

            <Button
              onClick={scrollToContact}
              variant="outline"
              className="border-white/50 text-white hover:bg-white/10 hover:text-white rounded-full px-8 py-6 text-base font-medium transition-all duration-300 bg-transparent"
              data-testid="hero-cta-secondary"
            >
              Request Project Details
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
